<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>订单管理</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" :model="searchData" class="demo-form-inline search-form form-list">
                    <el-form-item label="手机号" class="form_item">
                        <el-input placeholder="请输入" clearable v-model="searchData.phone"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                        <div class="button search export" @click="exportList" v-if="roleCheck('105-103-101-103')">
                            <span>导出</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-table
                highlight-current-row
                :data="listData">
                <el-table-column prop="phone" label="手机号"></el-table-column>
                <el-table-column label="提交时间" >
                    <template slot-scope="scope" >
                        <span>{{formDate(scope.row.old_create_time)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="shop_name" label="渠道" ></el-table-column>
                <el-table-column prop="order_id" label="订单号" ></el-table-column>
                <el-table-column prop="ali_pay_id" label="支付宝账号" ></el-table-column>
                <el-table-column label="优惠活动状态">
                    <template slot-scope="scope" >
                        <span class="finish" v-if="scope.row.old_status === 0">待审核</span>
                        <span class="finish" v-if="scope.row.old_status === 1">待发放</span>
                        <span class="send" v-if="scope.row.old_status === 2">已发放</span>
                        <span class="unshipped" v-if="scope.row.old_status === 3">审核未通过</span>
                    </template>
                </el-table-column>
                <el-table-column label="返现活动状态">
                    <template slot-scope="scope" >
                        <span class="finish" v-if="scope.row.cash_status === 0">待审核</span>
                        <span class="finish" v-if="scope.row.cash_status === 1">待发放</span>
                        <span class="send" v-if="scope.row.cash_status === 2">已发放</span>
                        <span class="unshipped" v-if="scope.row.cash_status === 3">审核未通过</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope" >
                        <div class="button text" @click="$router.push({name: 'renew-review', query: {id: scope.row.id}})" v-if="roleCheck('105-103-101-102')">审核</div>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
        </div>
        <Tip ref="tip" title="导出订单" msg="订单将直接发往您的飞书邮箱，确认要导出吗？">
            <template v-slot:confirm_btn>
                <div class="button del" @click="exportListConfirm">
                    <span>确定</span>
                </div>
            </template>
        </Tip>
    </div>
    
</template>
<script>
export default({
    name: 'renew-order',
    data() {
        return {
            searchData: {
                phone: '',
                page: 1,
                page_size: 10
            },
            listData: [],
            total: 0,
        }
    },
    watch: {
    },
    created() {
        // this.getList();
    },
    activated() {
        this.getList();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getList();
        },
        getList() {
            this.api.getRenewList(this.searchData).then(data => {
                this.listData = data.data.list;
                this.total = data.data.total;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        exportList() {
            // if(!this.createTime || this.createTime.length == 0) {
            //     this.$message('请先选择订单日期');
            //     return;
            // }
            this.$refs.tip.show = true;
        },
        exportListConfirm() {
            this.api.exportRenewOrderList().then(() => {
                this.$refs.tip.show = false;
            });
        }
    }
})
</script>
<style lang="less" scoped>
    .finish{
        color: #F8AF0C;
    }
    .send{
        color: #2A79FF;
    }
</style>



// WEBPACK FOOTER //
// src/view/product/renew/order.vue